import config from '../../config';

export default {
  create: {
    url: `${config.api
      .baseURL}/accounts/:accountId/babies/:babyId/sleep-records`,
    options: {
      method: 'POST'
    },
    transformer(data) {
      return data;
    }
  },
  list: {
    url: `${config.api
      .baseURL}/accounts/:accountId/babies/:babyId/sleep-records`,
    options: {
      method: 'GET'
    },
    transformer(data) {
      return data;
    }
  },
  latest: {
    url: `${config.api
      .baseURL}/accounts/:accountId/sleep-records`,
    options: {
      method: 'GET'
    },
    transformer(data) {
      return data;
    }
  },
  patch: {
    url: `${config.api
      .baseURL}/accounts/:accountId/babies/:babyId/sleep-records/:id`,
    options: {
      method: 'PATCH'
    },
    transformer(data) {
      return data;
    }
  },
  delete: {
    url: `${config.api
      .baseURL}/accounts/:accountId/babies/:babyId/sleep-records/:id`,
    options: {
      method: 'DELETE'
    },
    transformer(data) {
      return data;
    }
  }
};



// WEBPACK FOOTER //
// ./src/api/sleepRecords/index.js